module.exports = __webpack_public_path__ + "img/_SDI9220-2-1600.f8551da9.webp";